import { render, staticRenderFns } from "./ProductCardConfigurator.vue?vue&type=template&id=5e4b544e&scoped=true"
import script from "./ProductCardConfigurator.vue?vue&type=script&lang=js"
export * from "./ProductCardConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4b544e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e4b544e')) {
      api.createRecord('5e4b544e', component.options)
    } else {
      api.reload('5e4b544e', component.options)
    }
    module.hot.accept("./ProductCardConfigurator.vue?vue&type=template&id=5e4b544e&scoped=true", function () {
      api.rerender('5e4b544e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductCardConfigurator.vue"
export default component.exports